var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "67.000000pt",
    height: "67.000000pt",
    viewBox: "0 0 67.000000 67.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,67.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 624 c-24 -25 -24 -27 -27 -267 -4 -271 2 -308 48 -332 42 -22 507 -22 549 0 49 25 52 49 49 322 -3 250 -3 252 -27 277 l-24 26 -272 0 -272 0 -24 -26z m168 -179 c-6 -35 -6 -35 33 -35 35 0 38 2 44 35 5 26 12 35 26 35 24 0 25 -11 5 -113 -8 -43 -15 -81 -15 -83 0 -2 -10 -4 -21 -4 -20 0 -21 4 -16 45 l7 45 -39 0 c-38 0 -39 -1 -45 -45 -6 -38 -11 -45 -30 -45 l-24 0 14 78 c23 122 22 122 45 122 19 0 21 -4 16 -35z m313 8 c16 -21 20 -37 16 -62 -11 -71 -64 -111 -147 -111 l-41 0 6 33 c4 17 12 62 18 100 l11 67 58 0 c51 0 60 -3 79 -27z m100 -148 c0 -21 -9 -44 -25 -63 -87 -103 -388 -110 -480 -11 l-30 32 30 -20 c90 -62 283 -71 390 -18 57 27 95 71 95 108 0 10 5 15 10 12 6 -3 10 -21 10 -40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 408 c-4 -24 -9 -53 -13 -65 -4 -19 -1 -23 18 -23 30 0 43 9 58 37 17 33 14 71 -8 83 -36 19 -48 12 -55 -32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHd);
export default __webpack_public_path__ + "static/media/hd.702f56c5dba9a1a91d05ea51ca5e4a87.svg";
export { ForwardRef as ReactComponent };